<script>
import LayoutMember from '@layout/Member'
// import { messageWarning, messageSuccess } from '@utils/message'
import ValidDialog from '@components/Dialog/ValidDealer.vue'
import { mapState } from 'vuex'

export default {
  page() {
    return {
      title: `會員設定`,
    }
  },
  components: {
    LayoutMember,
    ValidDialog,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDialogValidVisible: false,
      buttonStyle: 'isStylePrimary isFull isRadius',
      dialogData: {
        type: 1, // 1 補欄位 2 驗證資格 3 詢問驗證
        title: '補齊欄位資料',
        text1: '請將欄位填寫完畢',
        text2: '並確認公司信箱是否正確',
      },
    }
  },
  computed: {
    ...mapState('auth', {
      companyLevel: (state) => state.companyLevel,
    }),
    menuList() {
      return [
        {
          title: '姓名',
          alias: 'name',
          value: this.defaultValue.name || '',
        },
        {
          title: '帳號(行動電話)',
          alias: 'phone',
          value: this.defaultValue.mobilePhone || '',
        },
        {
          title: '公司名稱',
          alias: 'company',
          value: this.defaultValue.company?.name || '',
        },
        {
          title: '身份',
          alis: 'id',
          value: this.defaultValue.group || '',
        },
      ]
    },
  },
  created() {
    this.checkVat()
  },
  methods: {
    async checkVat() {
      await this.$store
        .dispatch('global/checkVat', this.defaultValue?.company.vat)
        .then(({ items }) => {
          this.$store.dispatch('auth/setCompanyLevel', items.category_name)
        })
        .catch((e) => {
          console.log(e)
        })
    },
    async isDialog(kind) {
      if (kind === 1) {
        this.dialogData = {
          type: 2, // 1 補欄位 2 驗證資格 3 詢問驗證
          title: '收取驗證連結',
          text1: `已發送驗證連結至您的電子郵件${this.defaultValue.company.email}`,
          text2: '請點選信件內驗證連結進行升級',
        }
        await this.$store.dispatch('auth/sendDealerVaildEmail')
        this.isDialogValidVisible = true
      } else {
        this.isDialogValidVisible = true
      }
    },
  },
}
</script>
<template>
  <LayoutMember>
    <section class="section" :class="$style.memberInfo">
      <div class="text-center memberInfo__topBox">
        <div>
          <i class="icomoon icon-primary-user fa-5x"></i>
        </div>
        <div class="mt-3">會員基本資料</div>
      </div>
      <div>
        <div class="row border memberInfo__bottomBox mt-5 mobileGutter">
          <div v-for="(item, $index) in menuList" :key="$index" class="col-6 my-3">
            <template v-if="defaultValue.group === '經銷會員'">
              <div class="text-sm md:text-base color-gray-5">{{ item.title }}</div>
              <template v-if="!defaultValue.dealerValidate && $index === 3">
                <div class="text-base md:text-lg warningLevel">{{ item.value }}(未驗證)</div>
              </template>
              <template v-else-if="defaultValue.dealerValidate && defaultValue.dealerExpired && $index === 3">
                <div class="text-base md:text-lg warningLevel">{{ item.value }}(已過期)</div>
              </template>
              <template v-else-if="defaultValue.dealerValidate && $index === 3">
                <div class="text-base md:text-lg dealerLevel">{{ item.value }}</div>
              </template>
              <template v-else>
                <div class="text-base md:text-lg">{{ item.value }}</div>
              </template>
            </template>
            <template v-else>
              <div class="text-sm md:text-base color-gray-5">{{ item.title }}</div>
              <div class="text-base md:text-lg">{{ item.value }}</div>
            </template>
          </div>
        </div>
      </div>
      <BaseButton
        class="isStylePrimary isFull isRadius mt-5 mb-3"
        :to="{
          name: 'member-setting',
        }"
      >
        修改會員資料
      </BaseButton>
      <template v-if="!defaultValue.dealerValidate && companyLevel !== '一般'">
        <template v-if="defaultValue.group === '經銷會員' && defaultValue.dealerValidate === false">
          <BaseButton :class="buttonStyle" @click="isDialog(1)"> 立即驗證 > Go </BaseButton>
        </template>
        <template v-else>
          <BaseButton :class="buttonStyle" @click="isDialog(2)"> 驗證成為經銷會員 </BaseButton>
        </template>
      </template>
      <template v-else-if="defaultValue.dealerValidate && defaultValue.dealerExpired">
        <BaseButton :class="buttonStyle" @click="isDialog(1)"> 立即驗證 > Go </BaseButton>
      </template>
      <ValidDialog :visible.sync="isDialogValidVisible" :dialog-data="dialogData" @confirm="isDialogValidVisible = false" />
    </section>
  </LayoutMember>
</template>
<style lang="scss" module>
.memberInfo {
  :global {
    .memberInfo {
      &__bottomBox {
        padding: 1.5rem 1.56rem;
        background: #fff;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        @include max-sm {
          letter-spacing: 0.1em;
        }
        .normalLevel {
          border: 1px solid $color-gray-3;
        }
        .dealerLevel {
          // border: 1px solid $color-primary;
          color: $color-primary;
        }
        .warningLevel {
          // border: 1px solid $color-warning;
          color: $color-warning;
        }
      }
    }
  }
}
</style>
